<template>
    <li v-if="info.src" :class="info.ext" :data-hash="info.id" :id="'file-id-' + info.id">
        <a :href="$store.state.api + info.src" target="_blank">{{ info.title }}</a>
        <a v-if="token" href="" :data-id="info.id" :data-folder="info.invariant_folder.alias" @click.prevent="showModal" class="btn-remove btn btn-danger">Удалить</a>
    </li>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'File',
  props: ['info'],
  getData () {
    return {}
  },
  computed: {
    ...mapState({
      token: 'token'
    })
  },
  methods: {
    showModal (e) {
      this.$modal.show('confirm-modal')
      this.$store.commit('setSelectFolder', e.target.getAttribute('data-folder'))
      this.$store.commit('setSelectFile', e.target.getAttribute('data-id'))
    }
  }
}
</script>

<style lang="less">
  .btn-remove{
    margin-left: 10px;
  }
</style>
